<template>
  <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="56" height="55" fill="none" viewBox="0 0 56 55">
    <title>Small illustration of a baby carrier</title>
    <path
      fill-rule="evenodd"
      stroke="#05070F"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      d="M12.666 16.36v0c0 7.348 6.012 13.36 13.36 13.36h9.983c7.347 0 13.359-6.012 13.359-13.36S43.356 3 36.008 3v13.36H12.654h.013z"
      clip-rule="evenodd"
    />
    <path
      stroke="#05070F"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      d="M3.484 7.19l9.17 9.17M23.078 29.367l14.197 14.197"
    />
    <path
      fill-rule="evenodd"
      stroke="#05070F"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      d="M47.068 45.94c0 2.794-2.265 5.06-5.06 5.06-2.793 0-5.059-2.266-5.059-5.06 0-2.795 2.266-5.06 5.06-5.06 2.794 0 5.059 2.265 5.059 5.06z"
      clip-rule="evenodd"
    />
    <path stroke="#05070F" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M39.339 29.24L26.221 42.358" />
    <path
      fill="#FF0068"
      fill-rule="evenodd"
      d="M42.008 44.048c1.046 0 1.893.847 1.893 1.892s-.847 1.892-1.893 1.892c-1.044 0-1.891-.847-1.891-1.892s.847-1.892 1.892-1.892z"
      clip-rule="evenodd"
    />
    <path
      fill-rule="evenodd"
      stroke="#05070F"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      d="M26.786 45.94c0 2.794-2.265 5.06-5.06 5.06-2.793 0-5.058-2.266-5.058-5.06 0-2.795 2.265-5.06 5.059-5.06s5.06 2.265 5.06 5.06z"
      clip-rule="evenodd"
    />
    <path
      fill="#FF0068"
      fill-rule="evenodd"
      d="M21.727 44.048c1.045 0 1.892.847 1.892 1.892s-.847 1.892-1.892 1.892-1.892-.847-1.892-1.892.847-1.892 1.892-1.892z"
      clip-rule="evenodd"
    />
  </svg>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
  name: 'NannyIcon',
});
</script>
